import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { ApClassAttendanceDTOBase } from "./ApClassAttendanceDTOBase";
import type { ApClassSessionStaff } from "./ApClassSessionStaff";
import type { ApClassSignupStaff } from "./ApClassSignupStaff";
import type { TrackedBase } from "./TrackedBase";

export class ApClassAttendanceStaff implements ApClassAttendanceDTOBase, TrackedBase {
  constructor(public readonly attendId: number, public readonly attend: string | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly sessionId: ApClassSessionStaff | null, public readonly signupId: ApClassSignupStaff | null) {
    this.cbiServiceContext = null;
    this.sessionIdLoaded = this.sessionId != null;
    this.sessionIdCached = this.sessionId;
    this.signupIdLoaded = this.signupId != null;
    this.signupIdCached = this.signupId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private sessionIdLoaded: boolean;
  private sessionIdCached: ApClassSessionStaff | null;
  private signupIdLoaded: boolean;
  private signupIdCached: ApClassSignupStaff | null;
  async sessionIdLazy(): Promise<ApClassSessionStaff | null> {
    if (!this.sessionIdLoaded) {
      this.sessionIdCached = await this.cbiServiceContext!.apClassService().getApClassAttendanceStaffSessionId(this.attendId);
      this.sessionIdLoaded = true;
    }
    return this.sessionIdCached;
  }
  async signupIdLazy(): Promise<ApClassSignupStaff | null> {
    if (!this.signupIdLoaded) {
      this.signupIdCached = await this.cbiServiceContext!.apClassService().getApClassAttendanceStaffSignupId(this.attendId);
      this.signupIdLoaded = true;
    }
    return this.signupIdCached;
  }
}
